/**
 * 判断目标字符是否包含在字符串
 * @param str 字符串
 * @param keyword 目标字符串
 * @returns
 */
export const filterKeywords = (str = '', keyword = '') => str?.toLowerCase()?.includes(keyword?.toLowerCase());
